// Para elementos com role="button" que não são um <button> nativo — Enter/Espaço devem
// ativar a mesma ação do clique, senão o elemento fica invisível pra navegação por teclado.
export function onKeyActivate(handler) {
  return (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handler(e);
    }
  };
}
